import { render, staticRenderFns } from "./DoctorInfo.vue?vue&type=template&id=6a9aa940&scoped=true&"
import script from "./DoctorInfo.vue?vue&type=script&lang=js&"
export * from "./DoctorInfo.vue?vue&type=script&lang=js&"
import style0 from "./DoctorInfo.vue?vue&type=style&index=0&id=6a9aa940&lang=less&scoped=true&"
import style1 from "./DoctorInfo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9aa940",
  null
  
)

export default component.exports